import React from "react"
import Title from "../Title"
import Tag from './Tag'

import { Wrap,Center } from "./style"

const Tags = ({ tags }) => {
  return (
    <Wrap>
      <Title title={"Tags"} />
      <Center>
        {tags.map(tag => {
          return <Tag key={tag.id} {...tag} />
        })}
      </Center>
    </Wrap>
  )
}

export default Tags
